<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter" id="image002">
<img alt="image002" class="w" id="id-5360161100820920694" src="OEBPS/Images/1816646095033061554_image002.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section00.vue?4edc5c3c